import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  CATEGORY_PAGE_TYPES, LINE_PAGES, PRODUCT_PAGE_TYPES, TIRE_SIZE_PAGE,
} from "util/product/product-constants";
import useScreenSize from "./useScreenSize";

function usePreserveScroll() {
  const router = useRouter();
  const { currentPageType } = useSelector((store: RootState) => store.utils);
  const matchPageTypes = [...CATEGORY_PAGE_TYPES, ...PRODUCT_PAGE_TYPES, ...LINE_PAGES, TIRE_SIZE_PAGE];
  const [isMobile] = useScreenSize();

  useEffect(() => {
    if (!matchPageTypes.includes(currentPageType)) {
      return () => {};
    }

    const onRouteChangeStart = () => {
      if (isMobile) {
        return;
      }
      const url = router.asPath;
      if (!window.scrollPositions) {
        window.scrollPositions = {};
      }
      window.scrollPositions[url] = window.scrollY;
    };

    const onRouteChangeComplete = (url: any) => {
      if (window.isBack && window.scrollPositions && window.scrollPositions[url] && !isMobile) {
        window.scroll({
          top: window.scrollPositions[url],
          behavior: "auto",
        });
      }

      window.isBack = false;
    };

    router.events.on("routeChangeStart", onRouteChangeStart);
    router.events.on("routeChangeComplete", onRouteChangeComplete);

    return () => {
      router.events.off("routeChangeStart", onRouteChangeStart);
      router.events.off("routeChangeComplete", onRouteChangeComplete);
    };
  }, [router]);
}

export default usePreserveScroll;
